import { colors } from '../../../../../packages/colors';

export const sx = {
  // Root container
  rightPanel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: '16px',
    boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1)',
    overflow: 'hidden',
  },
  // Header section
  panelHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 24px',
  },
  headerContent: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'space-between',
  },
  headerIcon: {
    fontSize: '20px',
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: colors.neutral900,
  },
  countBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '24px',
    height: '24px',
    padding: '0 8px',
    borderRadius: '12px',
    border: `1px solid ${colors.secondary500}`,
    color: colors.secondary500,
    fontSize: '12px',
    fontWeight: 600,
  },
  // Body section
  panelBody: {
    flexGrow: 1,
    padding: '24px',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    '&::-webt-scrollbar': {
      display: 'none',
    },
  },

  // Footer section
  panelFooter: {
    padding: '16px 24px',
    backgroundColor: colors.white,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-40px',
      left: 0,
      right: 0,
      height: '40px',
      background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)',
      pointerEvents: 'none',
    },
  },

  // State containers
  centeredState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: '24px',
    textAlign: 'center',
  },
  stateIcon: {
    width: '65px',
    height: '65px',
    '& svg': {
      width: '65px !important',
      height: '65px !important',
    },
  },
  stateTitle: {
    fontSize: '18px',
    fontWeight: 600,
    color: colors.neutral900,
    marginBottom: '8px',
  },
  stateDescription: {
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.neutral700,
    fontWeight: 600,
  },
  emptyStateButton: {
    color: `${colors.primary500} !important`,
    fontSize: '14px !important',
    fontWeight: '700 !important',
    padding: `0px !important`,
    height: `auto !important`,
  },
  giggleText: {
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontWeight: 600,
    color: colors.neutral900,
    lineHeight: '20px',
  },
};
